import { TEST_TYPES } from 'Constants';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import { Save } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  FormControl,
  LinearProgress,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import scenarios from 'Api/scenarios';

const EditScenarios = ({ cancel, value, testId, reFetchProject, segment }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const { handleSubmit, register, formState, errors } = useForm();

  const onSubmit = (data) => {
    setIsLoading(true);
    scenarios
      .createScenarios({
        testId: testId,
        segmentId: segment.segmentid,
        totalScenarios: data.scenarios,
      })
      .then(async () => {
        reFetchProject();
        cancel();
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const renderForm = () => {
    if (!isLoading) {
      return (
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl fullWidth>
            <TextField
              select
              focused
              variant="outlined"
              fullWidth
              label="Number of scenarios"
              defaultValue={value}
              {...register('scenarios')}
              error={!!(errors && errors.scenarios)}
              helperText={errors?.scenarios?.message}
            >
              {Array.from(
                {
                  length: segment.testtype === TEST_TYPES.RECIRCULATION ? 8 : 5,
                },
                (_, i) => i + 1,
              ).map((value) => (
                <MenuItem key={value} value={value}>
                  <Typography>{value}</Typography>
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
          <Stack direction="row" justifyContent="space-between" mt={2}>
            <Button
              variant="contained"
              startIcon={<Save />}
              disabled={!formState.isDirty}
              type="submit"
            >
              Save
            </Button>
            <ButtonGroup>
              <Button onClick={cancel}>Cancel</Button>
            </ButtonGroup>
          </Stack>
        </form>
      );
    }
    return null;
  };

  return (
    <Stack p={2} spacing={2}>
      {isLoading && <LinearProgress />}
      <Typography variant="h5">Edit number of scenarios</Typography>
      <Box py={2}>{renderForm()}</Box>
      {!!error && <Alert severity="error">Error when updating scenarios</Alert>}
    </Stack>
  );
};

export default EditScenarios;
